module.exports = __webpack_public_path__ + "img/placeholders.02517f70.svg";